import React from 'react';

import _ from 'lodash';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';

export const Reactive = (annotations) => {

	return ComposedComponent => class extends React.Component {

		constructor(props) {
			super(props);
			this.state = {};
		}
		componentWillMount() {
			if (Meteor.isServer) return ;

			this.setState({
				isReady: false,
			});

			this._trackers = [];
			this._subscriptions = [];

			this.launch();

		}

		launch() {
			let subscriptions = this.state.subscriptions || [];

			console.log("subscriptions : ", subscriptions);
			console.log("annotations : ", annotations);

			/*
			 * Launch subscriptions
			 */
			let subscriptionsAreReady = [];
			_.each(annotations.subscriptions, (subscription) => {
				Tracker.nonreactive(() => {
					subscriptionsAreReady.push(new Promise((resolve, reject) => {
						let subscriptionName = subscription;
						let options = {};

						if (_.isObject(subscription)) {
							console.log("subcription is object");
							subscriptionName = subscription.name;
							if (subscription.paginate) {
								options.page = subscriptions[subscriptionName] ? subscriptions[subscriptionName].page : 1;
							}
							if (subscription.param) {
								options[subscription.param] = this.props.params[subscription.param];
							}

							options.query = subscriptions[subscriptionName] ? subscriptions[subscriptionName].query : '';
						}

						console.log("will subsribe", subscriptionName);
						const subscribed = Meteor.subscribe(subscriptionName, options, {
							onStop: (error) => {
								if (error)
									console.error(error);
							},
							onReady: () => {
								resolve(true);
							}
						});

						this._subscriptions.push(subscribed);
						subscriptions[subscriptionName] = {
							more: (() => {
								subscriptions[subscriptionName].page++;
								this.setState({ subscriptions });
								this.launch();
							}).bind(this),
							next: (() => {
								subscriptions[subscriptionName].page++;
								this.setState({ subscriptions });
								this.unsubscribe();
								this.launch();
							}).bind(this),
							clear: (() => {
								subscriptions[subscriptionName].query = false;
								subscriptions[subscriptionName].page = 1;
								this.setState({ subscriptions });
								this.unsubscribe();
								this.launch();
							}),
							search: ((query) => {
								subscriptions[subscriptionName].query = query;
								subscriptions[subscriptionName].page = 1;
								this.setState({ subscriptions });
								this.unsubscribe();
								this.launch();
							}).bind(this),
							query: subscriptions[subscriptionName] ? subscriptions[subscriptionName].query : '',
							page: subscriptions[subscriptionName] ? subscriptions[subscriptionName].page : 1
						}
					}));
				});
			});

			this.setState({ subscriptions });

			/*
			 * Set resources initial state
			 */
			_.each(annotations, (value, key) => {
				if (value && value.collection && value.reactive && value.matcher) {
					let modifier = {};
					modifier[key] = [];
					this.setState(modifier);
				}
			});

			/*
			 * Configure appropriate tracker for each resource when subscriptions are ready
			 */
			const ready = Promise.all(subscriptionsAreReady)
				.then(() => {
					!this.state.isReady && this.setState({
						isReady: true
					});
					_.each(annotations, (value, key) => {
						if (value && value.collection && value.reactive && value.matcher) {
							this._trackers.push(Tracker.autorun(() => {
								let modifier = {};
								modifier[key] = value.fetch();
								this.setState(modifier);
							}));
						}
					});

					return true;
				});
			this.setState({
				ready
			})
		}

		unsubscribe() {
			if (Meteor.isServer) return ;

			_.each(this._subscriptions, (subscription) => {
				console.log('subscription stop !');
				subscription.stop();
			});

			_.each(this._trackers, (tracker) => {
				tracker.stop();
			});
		}

		componentWillUnmount() {
			this.unsubscribe();
		}

		render() {
			return <ComposedComponent {...this.props} {...this.state} />;
		}
	};
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/common/Reactive.mixin.js
 **/